import GlossaryLink from '../glossary/GlossaryLink.js';
import GlossaryService from '../glossary/GlossaryService.js';
import React, { useEffect, Component, useRef, useMemo } from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import TranscriptButton from './TranscriptButton.js';
import Popup, { EnlargeImage } from './Popup.js';
import SearchBar from './SearchBar.js';
import { useHistory } from "react-router-dom";
import useAnalytics from './Analytics.js';
import HexDiagram from '../hacks/HexDiagram.js';
import SpinnyWheel from '../hacks/SpinnyWheel.js';
import RenaiEventAttendance from '../hacks/RenaiEventAttendance.js';
import EventDates from '../pages/EventDates.js';

function ApplyInjections(target, onSearch, data) {
    if (!target) return [];
    var base = document.getElementsByTagName('base')[0].getAttribute('href');
    var newElements = [];

    //activateAbsoluteURLs
    var as = target.getElementsByTagName("a");
    for (var i = 0; i < as.length; i++) {
        var href = as[i].getAttribute("href");
        if (href) {
            if (base != "/")
                href = href.replaceAll(base, "");
            if (href[0] == "/") {
                as[i].setAttribute("href", base + href.substr(1, href.length))
            }
        }
    }

    //activateGlossary
    if (GlossaryService.cachedList) {
        const glossary = GlossaryService.cachedList;
        var glossaryLinks = target.getElementsByClassName("glossary-link");         
        for (var i = 0; i < glossaryLinks.length; i++) {
            var id = glossaryLinks[i].getAttribute("data-entry");
            if (id) {
                for (var j = 0; j < glossary.length; j++) {
                    if (id.toLowerCase() === glossary[j].name.toLowerCase()) {                        
                        newElements.push(ReactDOM.createPortal(<GlossaryLink entry={glossary[j]} />, glossaryLinks[i]));
                        break;
                    }
                }
            }
        }
    }
    //event dates
    var eventDates = target.getElementsByClassName("event-dates");
    for (var i = 0; i < eventDates.length; i++) {
        newElements.push(ReactDOM.createPortal(<EventDates eventDates={data.eventDates} />, eventDates[i]));
    }
    //activateTranscript
    var buttons = target.getElementsByClassName("transcript-button");
    var contents = target.getElementsByClassName("transcript-content");
    for (var i = 0; i < buttons.length; i++) {
        var label = buttons[i].getAttribute("data-label") || "transcript";
        var big = buttons[i].hasAttribute("data-big");
        var paste = buttons[i].hasAttribute("data-paste");
        var hashName = buttons[i].parentNode.getAttribute("id") || "";
        var hidden = !buttons[i].hasAttribute("data-open");
        newElements.push(ReactDOM.createPortal(<TranscriptButton contentblock={contents[i]} label={label} big={big} paste={paste} hidden={hidden} hashName={hashName} />, buttons[i]));
    }

    //activatePopup
    var buttons = target.getElementsByClassName("popup-button");
    var titles = target.getElementsByClassName("popup-title");
    var contents = target.getElementsByClassName("popup-content");
    for (var i = 0; i < buttons.length; i++) {
        let isVideo = titles[i].classList.contains("popup-video");
        if(i < titles.length && i < contents.length)
            newElements.push(ReactDOM.createPortal(<Popup title={titles[i].innerHTML} content={contents[i].innerHTML} isVideo={isVideo} />, buttons[i]));
    }

    //activateEnlargeImage
    var gridItems = target.getElementsByClassName("grid-item-image"); 
    for (var i = 0; i < gridItems.length; i++) {
        newElements.push(ReactDOM.createPortal(<EnlargeImage item={gridItems[i].innerHTML} image={gridItems[i].getElementsByTagName("img")[0].getAttribute('src')} />, gridItems[i].parentNode));
    }

    //insert searchbars
    var searchbars = target.getElementsByClassName("searchbar-target");
    for (var i = 0; i < searchbars.length; i++) {
        
        const tip = searchbars[i].getAttribute("data-tip") || "Search the L&T Hub";
        const frontpageMode = searchbars[i].hasAttribute("data-frontpage");
        newElements.push(ReactDOM.createPortal(<SearchBar onSearch={onSearch} tip={tip} filter={""} autoFocus={true} fullWidth disableClearButton={true} frontpageMode={frontpageMode} />, searchbars[i]));
    }

    //automatically wrap iframes in responsive div if needed
    //activateIFrames
    var iframes = target.getElementsByTagName("iframe");
    for (var i = 0; i < iframes.length; i++) {
        if (!iframes[i].parentNode.classList.contains("embed-container")) {
            var par = document.createElement("div");
            par.classList.add("embed-container");
            var h = iframes[i].getAttribute("height"), w = iframes[i].getAttribute("width");
            if (h && w)
                par.style.paddingBottom = (100 * (parseFloat("" + h) / parseFloat("" + w))) + "%";
            iframes[i].parentNode.insertBefore(par, iframes[i]);
            par.appendChild(iframes[i]);
        }
    }

    
    //
    var renaiEventAttendances = target.getElementsByClassName("renai-event-action");
    for (var i = 0; i < renaiEventAttendances.length; i++) {
        newElements.push(ReactDOM.createPortal(<RenaiEventAttendance page={data} />, renaiEventAttendances[i]));
    }

    //re-hydrate scripts (they can't normally execute via innerHTML)
    var hexDiagram = document.querySelector(".hex-svg");
    if (hexDiagram) {
        HexDiagram();
    }
    var spinnyBoy = document.querySelector(".wheel-anim");
    if (spinnyBoy) {
        SpinnyWheel();
    }

    return newElements;
}

const NoRouterHijack = (props) => {
    let history = useHistory();
    const injected = useMemo(() => ApplyInjections(props.children.ref.current, (search) => {
        history.push("/search?sort=score&filter=" + search);
    }, props.data), [props.children, history]);

    return (
        <div>{props.children}{injected}</div>
    );
};

const defaultProtocols = ['mailto', 'tel'];
const defaultHostnames = [];
const getRoute = function(url) {
    var getLocation = function (href) {
        // eslint-disable-next-line no-useless-escape
        const re = /^(https?\:)?\/\/(([^:\/?#]*)(?:\:([0-9]+))?)([\/]{0,1}[^?#]*)(\?[^#]*|)(#.*|)$/
        const match = href.match(re)
        const location = match && {
            href: href,
            protocol: match[1],
            host: match[2],
            hostname: match[3],
            port: match[4],
            pathname: match[5],
            search: match[6],
            hash: match[7]
        }
        return match && location
    };

    // if it is an explicit non-http protocol, we want the browser to handle it natively
    // using history.push will do bad things
    const protocols = defaultProtocols;
    const hostnames = defaultHostnames;
    const nonHttpProtocol = protocols.some(protocol => url.startsWith(`${protocol}:`))
    if (nonHttpProtocol) { return false; }

    let destination = url;

    var base = document.getElementsByTagName('base')[0].getAttribute('href');
    const isApi = destination.indexOf("/api/") !== -1;
    if (isApi) return false;

    // if it's http or protocol-relative, we need to check further
    // we want to use react router if it's sending us to the same domain
    const re = new RegExp('^(https?:)?//')
    const isHTTP = re.test(url)
    if (isHTTP) {
        const { hostname, pathname, search, hash } = getLocation(url)
        const sameSite = (hostname === window.location.hostname && pathname.indexOf(base) === 0) || hostnames.indexOf(hostname) !== -1
        if (sameSite) {
            destination = pathname
            if (search) { destination += search }
            if (hash) { destination += hash }
        } else {
            // if it's an external http url, we let the browser handle it natively
            return false;
        }
    }

    if (base != "/" && destination.indexOf(base) === 0) {
        destination = destination.replace(base, "/");
    }

    return destination;
}


const Hijack = ({ children, history, data }) => {
    const [injected, setInjected] = React.useState([]);

    useEffect(() => {
        if (!children?.ref?.current) return;

        const elements = ApplyInjections(children.ref.current, (search) => {
            history.push("/search?sort=score&filter=" + search);
        }, data);

        setInjected(elements);
    }, [children, history, data]);

    useEffect(() => {
        return () => setInjected([]);
    }, []);

    const shouldRouterHandle = (url, event) => {
        var destination = getRoute(url);
        if (destination !== false) {
            if (destination[0] === "#") {
                window.location.hash = destination;
                var el = document.getElementById(destination.substring(1));
                if (el)
                    el.scrollIntoView({ behavior: 'smooth' });
            } else {
                if (destination.startsWith(window.location.pathname.substr(0)) || destination.startsWith(window.location.pathname.substr(1))) {
                    history.push(destination);
                    window.location.reload();
                } else {
                    history.push(destination);
                }
            }
            event.preventDefault();
        }
    };

    const onClick = (event) => {
        const { ctrlKey, shiftKey, metaKey } = event;
        if (ctrlKey || shiftKey || metaKey) {
            return;
        }

        const self = event.currentTarget;
        for (let el = event?.target; el !== self; el = el.parentElement) {
            if (!el)
                break;
            if (el.nodeName === 'A') {
                const target = el.getAttribute('target');
                if (target && target !== '_self' && target !== window.name) { return; }
                const href = el.getAttribute('href');
                href && shouldRouterHandle(href, event);
                break;
            }
        }
    };

    return <div onClick={onClick}>{children}{injected}</div>;
};
export default withRouter(Hijack);
export { NoRouterHijack, getRoute };
